import { render, staticRenderFns } from "./MediaAccreditation.vue?vue&type=template&id=1f19aa05&scoped=true&"
import script from "./MediaAccreditation.vue?vue&type=script&lang=js&"
export * from "./MediaAccreditation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f19aa05",
  null
  
)

export default component.exports